import { Fragment } from 'react';

import { AssetContentTypeEnum } from 'src/graphql/schema';
import { useAddDeposit } from 'src/context/deposit';
import { DialogTitle, DialogDescription, DialogHeader } from 'src/components/ui/dialog';

import IntegrationListContainer from './IntegrationListContainer';
import ManualUploadsContainer from './ManualUploadsContainer';

const contentTypeTitleMap = {
  [AssetContentTypeEnum.SourceCode]: 'Source code',
  [AssetContentTypeEnum.Documentation]: 'Documentation',
  [AssetContentTypeEnum.Data]: 'Data',
  [AssetContentTypeEnum.Deployment]: 'Deployment infrastructure & artifacts',
  [AssetContentTypeEnum.ThirdPartyDependency]: '3rd-party dependencies & services',
};

const SelectDepositMethodContainer = () => {
  const { contentType } = useAddDeposit();

  return (
    <Fragment>
      <DialogHeader className="gap-1.5 border-b p-6">
        <DialogTitle className="text-xl font-bold">
          Add {contentType ? contentTypeTitleMap[contentType as keyof typeof contentTypeTitleMap] : 'Deposit Method'}
        </DialogTitle>
        <DialogDescription className="text-muted-foreground">
          Choose how you want to deposit your assets into escrow. You can set up automated deposits through active
          integrations for seamless syncing, or use manual uploads to add specific files.
        </DialogDescription>
      </DialogHeader>

      <div className="space-y-6 bg-background-secondary p-6 overflow-y-auto rounded-b-lg">
        <ManualUploadsContainer />
        <IntegrationListContainer />
      </div>
    </Fragment>
  );
};

export default SelectDepositMethodContainer;
